module.exports = __webpack_public_path__ + "static/media/EXPERIENCEVR.0facfb21.svg";